import Index from '@/components/Admin/Index.vue'
import Login from '@/components/Admin/Login.vue'
import qrCode from '@/components/utils/qrCode.vue'
export default [{
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/qrCode/:text',
    name: 'qrCode',
    component: qrCode
  },
  {
    path: '/Index',
    name: 'Index',
    component: Index
  },
]



// WEBPACK FOOTER //
// ./src/routerConfig.js